import { motion } from 'motion/react';
import logoVoice from "../../assets/logos/Anuvadini Voice, Audio & Video.png";
import logoGames from "../../assets/logos/Anuvadini Games.png";
import logoDrafting from "../../assets/logos/Anuvadini Drafting & OCR.png";

const offerings = [
  {
    title: "Anuvadini Voice, Audio & Video",
    desc: "Deliver accurate lip-syncing, real-time translation, lifelike voice cloning, and audio modulation with natural results.",
    logo: logoVoice,
    color: "bg-orange-600/20",
    gradient: "from-[#f97316] via-[#db2777] to-[#4f46e5]",
    buttonBg: "bg-[#c2410c]",
    shadow: "shadow-orange-200",
    hideViewMore: false
  },
  {
    title: "Anuvadini Games",
    desc: "Interactive learning and engagement games including quizzes, multiplayer challenges, and classics like Snake & Ladder.",
    logo: logoGames,
    color: "bg-rose-600/20",
    gradient: "from-[#db2777] via-[#ec4899] to-[#db2777]",
    buttonBg: "bg-[#9d174d]",
    shadow: "shadow-rose-200",
    hideViewMore: false
  },
  {
    title: "Anuvadini Drafting & OCR",
    desc: "End-to-end document formatting and digitization with industry-grade tooling. OCR for handwritten and legacy documents.",
    logo: logoDrafting,
    color: "bg-amber-600/20",
    gradient: "from-[#008080] via-[#008080] to-[#008080]",
    buttonBg: "bg-[#008080]",
    shadow: "shadow-amber-200",
    hideViewMore: true
  }
];

type SpecializedOfferingsProps = {
  onContact: () => void;
  onShowProductDetail?: (product: any) => void;
};

export const SpecializedOfferings = ({ onContact, onShowProductDetail }: SpecializedOfferingsProps) => {
  return (
    <section id="specialized-offerings" className="py-16 sm:py-20 md:py-24 bg-rose-500 overflow-hidden relative scroll-mt-28">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.5" fill="white" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="mb-12 sm:mb-16">
          <span className="text-white/80 font-bold uppercase tracking-widest text-xs sm:text-sm">Extended Solutions</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-3 sm:mt-4 leading-tight text-justify-inter-word">
            Specialized offerings for multimedia, gaming, and digitization.
          </h2>
        </div>

         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {offerings.slice(0, 4).map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={` p-4 sm:p-6 md:p-8 rounded-[2.5rem] group hover:bg-white/20 transition-all flex flex-col h-full ${
  index === 0 
    ? "bg-gradient-to-br from-sky-200 via-blue-300 to-sky-400 border border-sky-300]"
    : index === 1
    ? "bg-gradient-to-br from-purple-200 via-violet-300 to-fuchsia-400 border border-purple-300"
    : "bg-gradient-to-br from-emerald-400 via-teal-500 to-teal-600 border border-emerald-500 "
                }`}
            >
              <div className="rounded-2xl  w-fit mb-6 sm:mb-8">
                <img src={item.logo} alt={`${item.title} Logo`} className="h-16 sm:h-20 mr-10 object-contain rounded-2xl" />
              </div>

              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4 leading-tight">{item.title}</h3>
              <p className="text-rose-50 leading-relaxed mb-8 sm:mb-10 text-justify-inter-word flex-grow text-sm sm:text-base">
                {item.desc}{" "}{onShowProductDetail && !item.hideViewMore && (
                  <button
                    type="button"
                    onClick={() => onShowProductDetail(item)}
                    className="text-white font-semibold text-xs sm:text-sm uppercase tracking-wider underline decoration-2 underline-offset-4 hover:text-yellow-200 hover:decoration-yellow-200 transition-colors cursor-pointer bg-transparent border-0 p-0 text-left"
                  >
                    VIEW MORE
                  </button>
                )}
              </p>

              {/* Action Buttons */}
              <div className={`grid gap-3 mt-auto ${"grid-cols-1"}`}>
                
                  <button type="button"
                  onClick={onContact} className="py-3 lg:py-4 bg-green-400 hover:bg-green-500 text-white rounded-2xl font-black text-[10px] lg:text-xs uppercase tracking-widest shadow-xl hover:scale-[1.02] transition-all active:scale-95 border border-white/5">
            CONTACT ANUVADINI
          {/* </button> */}
                </button>

                
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
